import { Flex, StepIndicator, type Step } from "@jsq/ds/core";

export type StepNavigationProps = {
  steps: Step[];
};

// StepIndicator is @deprecated but matches EntityClientCaseWizard/InvestorCaseWizard's precedent.
export const StepNavigation = ({ steps }: StepNavigationProps) => {
  return (
    <Flex flexDirection="row">
      <StepIndicator steps={steps} disableStepLinks noPadding />
    </Flex>
  );
};
